import React from 'react'
import styled from 'styled-components'
import { Navbar, Content } from './shared'
import { CookieConsent } from './shared/CookieConsent'

export const AuthLayout = ({ children }) => {
  return (
    <>
      <Root>
        <Navbar hideNavContent />
        <StyledContent>{children}</StyledContent>
      </Root>
      <CookieConsent />
    </>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 100%;
  width: 100%;
  min-height: 100%;
  padding-bottom: 90px;
`
const StyledContent = styled(Content)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
